import { Icon } from '@frontend/icons';
import { MetricSentiment } from './types';

export const METRIC_VALUE_ICONS: Record<MetricSentiment, JSX.Element> = {
  positive: <Icon name='confirm-badge' color='success' />,
  warn: <Icon name='warning-badge' color='warn' />,
  negative: <Icon name='error-badge' color='error' />,
} as const;
